import type { DatasetFileUploadProps } from "./dataset-file-upload.type";
import type { DatasetFileCreateVariables } from "@/entities/dataset";
import type {
  UploadCustomRequest,
  UploadFileProps,
  UploadOnChange,
} from "@/modules/upload-file";

import { DATASET_TYPE } from "@/entities/dataset";
import { useDatasetsMutatorSync } from "@/modules/datasets/datasets-mutator";

import { getSchemaAuthorizedUploadFileTypes } from "./dataset-file-upload.helper";

const datasetType = DATASET_TYPE.FILE;

export const useDatasetFileUpload = ({
  template,
  ...customUploadProps
}: DatasetFileUploadProps) => {
  const fileTypes = getSchemaAuthorizedUploadFileTypes(template);

  const { addMutatorItem, removeMutatorItem } = useDatasetsMutatorSync();

  const customRequest: UploadCustomRequest = ({ file }) => {
    if (typeof file === "string" || !("uid" in file)) return;

    const variables: DatasetFileCreateVariables = {
      type: datasetType,
      name: file.name,
      data: file,
      layout_index: template.layout_index,
    };

    addMutatorItem({
      mutationType: "create",
      datasetType,
      variables,
    });
  };

  const onChange: UploadOnChange = ({ file }) => {
    switch (file.status) {
      case "removed": {
        // Remove create operation from stack
        removeMutatorItem({ datasetType });
        break;
      }
      case "uploading":
        // Don't want to display "...Uploading"
        delete file.status;
        break;
    }
  };

  const uploadProps: UploadFileProps = {
    maxCount: 1,
    multiple: false,
    ...customUploadProps,
    fileTypes,
    customRequest,
    onChange,
  };

  return {
    uploadProps,
  };
};
